/** Money is integer kuruş everywhere. ₺1 = 100 kuruş. */
export const TIER_KEYS = ['loca', 'on', 'arka', 'balkon'] as const;
export type Tier = (typeof TIER_KEYS)[number];
export type TierPrices = Record<Tier, number>;

export const TIERS: Record<Tier, { tr: string; en: string; css: string }> = {
  loca: { tr: 'Loca', en: 'Box', css: 'var(--t-loca)' },
  on: { tr: 'Ön Parter', en: 'Front Stalls', css: 'var(--t-on)' },
  arka: { tr: 'Arka Parter', en: 'Rear Stalls', css: 'var(--t-arka)' },
  balkon: { tr: 'Balkon', en: 'Balcony', css: 'var(--t-balkon)' },
};

/** Service fee per ticket (prototype: "Bilet başına ₺15 hizmet bedeli"). */
export const FEE_KURUS = 1500;
export const MAX_SEATS = 8;
export const MAX_SEATS_DEMAND = 4;

export interface PricedLine {
  seatId: string;
  tier: Tier;
  priceKurus: number;
}

export interface OrderTotals {
  lines: PricedLine[];
  subtotalKurus: number;
  feeKurus: number;
  totalKurus: number;
}

export function priceSeats(prices: TierPrices, seats: { id: string; tier: Tier }[]): OrderTotals {
  if (!seats.length) throw new Error('no_seats');
  const lines = seats.map((s) => {
    const p = prices[s.tier];
    if (!Number.isInteger(p) || p < 0) throw new Error(`no_price_for_${s.tier}`);
    return { seatId: s.id, tier: s.tier, priceKurus: p };
  });
  const subtotalKurus = lines.reduce((a, l) => a + l.priceKurus, 0);
  const feeKurus = FEE_KURUS * lines.length;
  return { lines, subtotalKurus, feeKurus, totalKurus: subtotalKurus + feeKurus };
}

export const minPrice = (p: TierPrices) => Math.min(...TIER_KEYS.map((k) => p[k]));

/** "₺1.530" (tr) — prototype formatting: whole lira, tr-TR grouping. */
export const tl = (kurus: number, lang: 'tr' | 'en' = 'tr') =>
  '₺' + Math.round(kurus / 100).toLocaleString(lang === 'en' ? 'en-GB' : 'tr-TR');

export const maxSeatsFor = (demand: boolean) => (demand ? MAX_SEATS_DEMAND : MAX_SEATS);
